import React from 'react'
import { useState } from 'react'

const Contact = () => {

  const [data,setData] = useState({
    fullname: "",
    mobile: "",
    email: "",
    message: ""
  })

  const inputEvent = (event)=>{
    const {name, value} = event.target;

    setData((prevData)=>{
      return{
      ...prevData,
      [name]: value,
      };
    });
  }; 

  const formSubmit = (e)=>{
      e.preventDefault();

      alert(`Hi ${data.fullname} your mobile number: ${data.mobile} and your email id: ${data.email} is Succesfully Submited with your message: ${data.message}`)
  }

 


  return (
    <>
      <div className='my-4'>
        <h1 className='text-center'>Contact Us</h1>
      </div> 
      <div className='container contact_div'>
        <div className='row'>
          <div className='col-md-12 col-sm-10 mx-auto col-10'>
            <form onSubmit={formSubmit}> 
              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label mb-0">FullName</label>
                <input type="text" className="form-control" name='fullname' value={data.fullname} onChange={inputEvent} placeholder="Enter your Name"/>
              </div>

              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label mb-0">Mobile</label>
                <input type="number" className="form-control" name='mobile' value={data.mobile} onChange={inputEvent} placeholder="Mobile Number"/>
              </div>

              <div className="mb-3">
                <label htmlFor="exampleFormControlInput1" className="form-label mb-0">Email address</label>
                <input type="email" className="form-control" name='email' value={data.email} onChange={inputEvent} placeholder="name@example.com"/>
              </div>

              <div className="mb-3">
                <label htmlFor="exampleFormControlTextarea1" className="form-label mb-0">Message</label>
                <textarea className="form-control" id="exampleFormControlTextarea1" rows="3" name='message' value={data.message} onChange={inputEvent} placeholder='Message'></textarea>
              </div>

              <div className="col-auto">
                <button type="submit" className="btn btn-outline-primary mb-3">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default Contact
